import React from "react";

const ErrorDiv = (props) =>
{
    const style = { color: 'red'};
    return <div style={style}>{props.children}</div>
}

export default ErrorDiv ;